import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Shield, Zap, CheckCircle2, FileText, Download, Infinity } from 'lucide-react';
const technicalCheckpoints = [{
  text: 'Formato PDF + Planillas de trabajo.',
  icon: FileText
}, {
  text: 'Listo para descargar y usar de inmediato.',
  icon: Download
}, {
  text: 'Acceso de por vida (Vitalicio).',
  icon: Infinity
}];
const benefits = ['Explorar tu sistema familiar con total claridad y dominio de la técnica.', 'Eliminar bloqueos, dudas e inseguridades al mirar tus dinámicas ancestrales.', 'Contar con guiones, preguntas clave y protocolos listos para cada paso del camino.', 'Profundizar en nudos sistémicos complejos sin sentirte abrumado o estancado.', 'Vivir una experiencia de transformación profunda, profesional y estructurada.'];
export function InfraestructuraSistemica() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return;
}